import React from 'react';
import * as Ons from 'react-onsenui';
import TripleSwitch from '../Controls/TripleSwitch';
import { translate as _ } from '../../util/i18n';

class Checklist extends React.Component {

    #inputNames;

    constructor( props ) {

        super( props );

        this.handleChange = this.handleChange.bind( this );

        this.setInputNames();

    }

    componentDidUpdate() {

        this.setInputNames();

    }

    getInputName( e ) {

        return 'grr-checklist-' + this.props.id + '-' + e;

    }

    handleChange( e ) {

        this.props.onChange( { ...this.props.values, [ this.#inputNames[ e.target.name ] ]: e.target.value } );

    }

    setInputNames() {

        this.#inputNames = {};

        this.props.config.forEach( e => { this.#inputNames[ this.getInputName( e.key ) ] = e.key; } );

        this.#inputNames[ this.getInputName( 'isOk' ) ] = 'isOk';

    }

    renderInput( item ) {

        const props = {

            modifier:    'underbar',
            onChange:    e => this.handleChange( { target: { name: this.getInputName( item.key ), value: e.target.value } } ),
            placeholder: this.props.inputPlaceholder,
            type:        'text',
            value:       this.props.values[ item.key ]

        };

        if ( this.props.disabled ) {

            props.readonly = true;

        }

        return (

            <Ons.Input {...props} />

        );

    }

    render() {

        // console.log( 'components.GameReportReferee.Checklist.render()', this.props, this.state );

        return (

            <div>

                <div className="form-control">

                    <label>{_( 'Alles OK' )}</label>

                    <div className="switch-container">

                        <TripleSwitch
                            disabled={this.props.disabled}
                            name={this.getInputName( 'isOk' )}
                            onChange={this.handleChange}
                            value={this.props.values.isOk}
                        />

                    </div>

                </div>

                {this.props.values.isOk === false &&

                    <div>

                        {this.props.config.map( item =>

                            <div key={item.key}>

                                <div className="form-control">

                                    <label htmlFor={this.getInputName( item.key )}>{_( item.title )}</label>

                                    <div className="switch-container">

                                        <Ons.Switch
                                            checked={this.props.values[ item.key ] === null}
                                            class="switch-ac"
                                            disabled={this.props.disabled}
                                            inputId={this.getInputName( item.key )}
                                            onChange={e => this.handleChange( { target: { name: this.getInputName( item.key ), value: e.value === false ? '' : null } } ) }
                                        />

                                    </div>

                                </div>

                                {this.props.values[ item.key ] !== null &&

                                    <div className="form-control">

                                        {this.renderInput( item )}

                                    </div>

                                }

                            </div>

                        )}

                    </div>

                }

            </div>

        );

    }

}

export default Checklist;